import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import { categories } from "@/mocks/categories";

export default function VideoCard({ video }: { video: VideoItem }) {
  const cat = categories.find((c) => c.id === video.categoryId);
  return (
    <article className="group overflow-hidden rounded-xl bg-background-50 ring-1 ring-inset ring-background-200 transition hover:ring-primary-300">
      <Link to={`/videos/${video.id}`} className="block">
        <div className="relative aspect-video w-full overflow-hidden">
          <img
            src={video.cover}
            alt={`${video.title} 视频封面`}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          />
          <span className="absolute bottom-2 right-2 rounded bg-foreground-950/70 px-1.5 py-0.5 text-xs font-medium text-background-50">
            {video.duration}
          </span>
          <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
            {cat?.name ?? "资讯"}
          </span>
          <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/0 opacity-0 transition group-hover:bg-foreground-950/20 group-hover:opacity-100">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
              <i className="ri-play-fill text-lg" />
            </span>
          </div>
        </div>
      </Link>
      <div className="p-4">
        <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 md:text-base">
          <Link to={`/videos/${video.id}`} className="transition hover:text-primary-600">
            {video.title}
          </Link>
        </h3>
        <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" /> {video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-thumb-up-line" /> {video.likes >= 10000 ? `${(video.likes / 10000).toFixed(1)}万` : video.likes}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line" /> {video.comments >= 10000 ? `${(video.comments / 10000).toFixed(1)}万` : video.comments}
          </span>
        </div>
      </div>
    </article>
  );
}